export default __webpack_public_path__ + "static/media/GBP.91c9d960.svg";